import { Heading, Stack, Text } from '@chakra-ui/react'
import { createFileRoute, Outlet } from '@tanstack/react-router'

import { Crawls } from '@/corpus/Crawls'

export const Route = createFileRoute('/admin/crawls')({ component: CrawlsPage })

/**
 * What is on its way into the corpus.
 *
 * A section of its own, beside the corpus rather than above it. What an
 * operator does here is put work in front of Scout and then watch it land,
 * which is a different job from reading what Scout can already answer from —
 * and this list grows a row for every ask, including the ones a crawl will one
 * day add for itself.
 *
 * A layout rather than a page, so that opening one request's log leaves this
 * mounted. The table polls while anything is unfinished, and remounting it to
 * show a log beside it would restart every one of those polls and lose the
 * scroll position an operator was reading from.
 */
function CrawlsPage() {
  return (
    <Stack gap="4" align="stretch">
      <Stack gap="1" align="stretch">
        <Heading size="md">Crawls</Heading>
        <Text color="fg.muted" fontSize="sm">
          A crawl fetches one page, cuts it into the chunks retrieval searches, and reads it for
          what it says about the product. Each stage is reported as it lands.
        </Text>
      </Stack>
      <Crawls />
      {/* The panel, where a request's log opens. Empty at /admin/crawls. */}
      <Outlet />
    </Stack>
  )
}
